import { render } from "./HeroiconsSolidClipboardList.vue?vue&type=template&id=30ab0c02"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidClipboardList.vue"]])

export default __exports__